import { render, staticRenderFns } from "./MenuHorizontalScroll.vue?vue&type=template&id=e55c1ce8&scoped=true&"
import script from "./MenuHorizontalScroll.vue?vue&type=script&lang=js&"
export * from "./MenuHorizontalScroll.vue?vue&type=script&lang=js&"
import style0 from "./MenuHorizontalScroll.vue?vue&type=style&index=0&id=e55c1ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55c1ce8",
  null
  
)

export default component.exports